"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._mapOptions = void 0;
const _mapOptions = (options) => {
    return {
        separator: options.thousandsSeparator,
        decimal: options.decimalSeparator,
        pattern: "#",
        negativePattern: "-#",
    };
};
exports._mapOptions = _mapOptions;
